(function ($, DGS) {
  'use strict';

  var burgerMenuConfig = {
    animateDirection: 'right',
    //default:left
    animateBtn: false,
    //default true
    buttonPlacement: 'left',
    // default right
    closeOnOutsideClick: true //default false
  };
  var megaMenuConfig = {
    openOnHover: true //default false
  };
  DGS.OnLoad.getInstance().register(function () {
    var sectionShown,
      $logo = $('#header .image'),
      $menu = $('#header .navigation'),
      $search = $('#header .search-field-spot'),
      $hclButton = $('#header .link.hcl-button'),
      $mainContainer = $('#wrapper > #header'),
      headerSettings = {
        mainContainer: $mainContainer,
        determineSectionCallback: function determineSectionCallback(section) {
          //sectionShown = section;

          if (DGS.UserAgent.getInstance().mobileTabletCheck()) {
            sectionShown = DGS.MOBILE_LAYOUT;
            return DGS.MOBILE_LAYOUT;
          } else {
            sectionShown = DGS.DESKTOP_LAYOUT;
            return DGS.DESKTOP_LAYOUT;
          }
        },
        sections: {
          mobile: {
            containers: [{
              className: 'header-mobile-top',
              components: [$logo, $('<div class="nav-expander"><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span></div>'), $hclButton]
            }, {
              className: 'header-mobile-menu',
              components: [$menu]
            }]
          },
          desktop: {
            containers: [{
              className: 'header-desktop-top',
              containers: [{
                className: 'row-1',
                components: [$logo, $search, $hclButton]
              }, {
                className: 'row-2',
                components: [$menu]
              }]
            }]
          }
        }
      };
    DGS.Event.getInstance().on(DGS.Events.BUILDER_DONE, function (settings) {
      if (settings !== headerSettings) return; // ONLY RUN IF IT'S THE

      $('#header').addClass('animate');

      // SETUP BURGER MENU
      var backButton = '<div class="nav-back">Back</div>';
      $(".mobile-section .navigation").before(backButton);
      $('.mobile-section .navigation .component-content > ul').burgerMenu({
        expanderSelector: '.header-mobile-top .nav-expander',
        menuItemsClass: "text-left"
      });

      // ADJUST BURGER MENU POSITION
      $('.dgs-burger-menu').css('top', $('.header-mobile-top').outerHeight());
      $('.nav-back').css('top', $('.header-mobile-top').outerHeight());
    });

    // BUILD MARKUP
    DGS.Builder.build(headerSettings);

    // SETUP MEGA MENU
    $(".desktop-section .navigation .component-content > ul").megaMenu({
      hover: true
    });

    // REGISTER RESIZER HANDLER
    DGS.OnContentLoaded.getInstance().register(function () {
      DGS.Resizer.getInstance().register(function () {
        // ADJUST CONTENT SECTION BY ADDING BOTTOM MARGIN TO HEADER
        var headerHeight = 0;
        if (sectionShown == DGS.DESKTOP_LAYOUT) {
          headerHeight = $('#header .desktop-section > .inner-container').outerHeight();
        } else if (sectionShown == DGS.MOBILE_LAYOUT) {
          headerHeight = $('#header .header-mobile-top').outerHeight();
        }
        $('#header').css('margin-bottom', headerHeight);
      });
    });

    // Prevent browser from showing tooltip with title attributes
    var $attr = $('[title]');
    $attr.hover(function () {
      var title = $(this).attr("title");
      $(this).attr("temp-title", title);
      $(this).attr("title", "");
    });
    $attr.click(function () {
      var title = $(this).attr("temp-title");
      $(this).attr("title", title);
    });
    // Prevent browser from showing tooltip with title attributes - end

    // SHOW DIMMER ON HOVER
    $('#wrapper #header ul.dgs-mega-menu > li').hover(function () {
      // Only show Dimmer if there is a flyout
      if ($(this).hasClass('no-dropdown')) {
        return;
      }
      var dimmer = $('#Dimmer');

      // / Add dimmer if not existing
      if (dimmer.length <= 0) {
        dimmer = $('body').append('<div id=\"Dimmer\"></div>');
      }

      // If dimmer exists - ensure its shown
      if (dimmer.hasClass('hidden')) {
        dimmer.removeClass('hidden');
      }
    }, function () {
      var dimmer = $('#Dimmer');
      var linkObj = $(this).closest('.level1').find('a.current');

      // Remove dimmer
      if (dimmer.length > 0 && linkObj.hasClass('active') === false) {
        dimmer.addClass('hidden');
      }
    });

    //Adjust HCL-Button Link component to use styling of other like-buttons
    $('#header .link.hcl-button .component-content a').wrapInner('<span class="like-button-hcl"></span>');

    // Popup used on Italian website (markup injected in Sitecore under Settings -> Tags Settings)
    $('.once-per-session.popup').each(function () {
      var $this = $(this),
        cookie = DGS.Cookies.getInstance().readCookie("italian-medical-alert");
      if (!cookie) {
        $this.addClass('popup-show');
        $('.popup-close', $this).click(function () {
          DGS.Cookies.getInstance().createCookie("italian-medical-alert");
          $this.removeClass('popup-show');
        });
      }
    });
  });
})(jQuery, window.DGS);